import React from 'react';
import { fabric } from "fabric";
import LoadingOverlay from 'react-loading-overlay';
import './fabricjs/PRRect';
import './fabricjs/PRBase';
import ProofreadFile from '../lib/ProofreadFile';
import './ProofreadCanvas.css';
import Utils from '../lib/Utils';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearchPlus, faSearchMinus/*, faGlasses*/, faSquarePlus, faMessage, faCropSimple, faTrash } from "@fortawesome/free-solid-svg-icons";
import { faImage } from "@fortawesome/free-regular-svg-icons";

import ProofreadHist from '../lib/ProofreadHist';

class ProofreadCanvas extends React.Component {
  state = {
    loading: "読み込み中",

    actionButton: null,
    editDialogTitle:null,
    editDialogToRemoveOnCancel:false, // キャンセル時に指示を削除
    photoSelector:null, //写真選択メニュー
    loadingPhotoSelector:null,

    uploadedPhotos:[], // 写真一覧
  };
  canvas = null;
  dragStart; // ドラッグ開始Point
  drawStart; // 枠作成中
  scrollPixels = {w:5000, h:3500};
  pressKey = null;

  componentDidMount(){
    // キャンバス作成
    fabric.Object.prototype.lockScalingFlip = true;
    //fabric.Object.prototype.padding = 0;
    fabric.ActiveSelection.prototype.hasControls = false;
    this.canvas = new fabric.Canvas('ProofreadCanvas', {
      width: this.props.canvasWidth,
      height: this.props.canvasHeight,
      backgroundColor: "#80beaf",
      uniformScaling:false,
      selection:false,
      noScaleCache: true,
    });
    //this.canvas.freeDrawingBrush.color = "#fff";
    //this.canvas.freeDrawingBrush.width = 800;

    this.canvas.minimumSize = Math.round(10/*mm*/ * 3.779528);

    this.canvas.on('mouse:down', opt => {
      let pointer = this.canvas.getPointer(opt.e, true);
      this.dragStart = new fabric.Point(pointer.x, pointer.y);
      if (this.props.tool.match(/^draw-/) && !this.canvas.getActiveObject()) {
        if (this.props.tool !== 'draw-changeChar') {
          // 指示枠の作成開始
          this.drawStart = true;
          let vpt = this.canvas.vptCoords.tl
          let p = this.dragStart.divide(this.canvas.getZoom()).add(vpt);
          let rect = new fabric.PRRect({
            width:0,
            height:0,
            left: p.x,
            top:p.y,
            creator: 'customer',
          });
          this.canvas.add(rect).requestRenderAll();
          this.canvas.setActiveObject(rect);
        }
        else { //draw-changeChar
          let vpt = this.canvas.vptCoords.tl
          let p = this.dragStart.divide(this.canvas.getZoom()).add(vpt);
          let point = new fabric.PRRect({
            left: p.x,
            top:p.y,
            creator: 'customer',
            directionType:'changeCharTarget',
          });

          let textRect = new fabric.PRRect({
            left: p.x,
            top:p.y-70,
            width:140,
            height:45,
            creator: 'customer',
            directionType:'changeChar',
            targetTimestamp: point.createdTimestamp
          });

          this.canvas.add(point).add(textRect).requestRenderAll();
          this.canvas.setActiveObject(point);

          //ProofreadHist.push(this.createSaveData());
          this.props.event({name:'UpdatePRRect'});
        }
        
      }
      else if (this.props.tool === 'remove') { // 削除ツール
        let obj = this.canvas.getActiveObject();
        if (!obj || obj.type !== 'PRRect') return;
        if (['change', 'move', 'changeChar'].indexOf(obj.directionType)>=0) {
          let targetFrame = this.canvas.getObjects().find(o=>o.createdTimestamp === obj.targetTimestamp);
          if (targetFrame) this.canvas.remove(targetFrame);
        }
        else if (obj.directionType.match(/Target$/)) {
          ProofreadHist.push(this.createSaveData());
          let parent = this.canvas.getObjects().find(o=>{
            if (!o.targetTimestamp) return false;
            return o.targetTimestamp === obj.createdTimestamp;
          });
          if (parent) this.canvas.remove(parent);
        }
        this.canvas.remove(obj);
        ProofreadHist.push(this.createSaveData());
        this.props.event({name:'UpdatePRRect'});
      }
      else {
        this.selectDirection(null);
        this.props.event({name:'ClickCanvas'});
      }
    });
    this.canvas.on('mouse:up', opt=>{
      if (this.pressKey === 'space') {}
      else if (this.props.tool === 'zoomPlus' || this.props.tool === 'zoomMinus') {
        // ズームツール
        let pointer = this.canvas.getPointer(opt.e, true);
        let dragEnd = new fabric.Point(pointer.x, pointer.y);

        let diffX = Math.abs(dragEnd.x - this.dragStart.x);
        let diffY = Math.abs(dragEnd.y - this.dragStart.y);

        if ((this.dragStart.x === dragEnd.x && this.dragStart.y === dragEnd.y) || (diffX < 10 || diffY < 10)) {
          // クリック位置でズーム
          this.canvas.absolutePan(dragEnd.add(this.canvas.vptCoords.tl.multiply(this.canvas.getZoom()))); // 中心を原点に移動
          let zoom = this.props.tool === 'zoomPlus' ? 1.2 : 0.8333;
          this.canvas.setZoom(this.canvas.getZoom()*zoom);
          let canvasSize = new fabric.Point(this.canvas.getWidth(), this.canvas.getHeight());
          this.canvas.relativePan(canvasSize.divide(2));

          //this.canvas.zoomToPoint(dragEnd, this.canvas.getZoom()*zoom);
        }
        else {
          // 選択範囲をズーム
          let zoomV = this.canvas.getHeight() / diffY;
          let zoomH = this.canvas.getWidth()  / diffX;
          let zoom = Math.min(zoomV, zoomH);
          if (this.props.tool === 'zoomMinus') zoom = 1 / zoom;
          let pointX = Math.min(this.dragStart.x, dragEnd.x) + diffX/2;
          let pointY = Math.min(this.dragStart.y, dragEnd.y) + diffY/2;
          
          let newPoint = new fabric.Point(pointX, pointY);
          this.canvas.absolutePan(newPoint.add(this.canvas.vptCoords.tl.multiply(this.canvas.getZoom()))); // 中心を原点に移動
          this.canvas.setZoom(this.canvas.getZoom()*zoom);
          let canvasSize = new fabric.Point(this.canvas.getWidth(), this.canvas.getHeight());
          this.canvas.relativePan(canvasSize.divide(2));
          
        }

        this.canvasToScrollbar();
        this.canvas.requestRenderAll();
      }
      else if ((this.props.tool.match(/^draw-/) && this.drawStart) || this.props.tool === 'draw-changeChar') {
        // 指示枠の作成完了
        let rect = this.canvas.getActiveObject();
        if (rect && (rect.width === 0 || rect.height === 0)) {
          // サイズが0の場合枠を削除
          this.canvas.remove(rect);
        }
        else {
          let refine = {};
          let c = rect.getPointByOrigin('center', 'center');
          if (rect.width  < this.canvas.minimumSize) {
            refine.width  = this.canvas.minimumSize;
            let diffX = (refine.width -rect.width) /2;
            refine.left = c.x + diffX;
          }
          if (rect.height < this.canvas.minimumSize) {
            refine.height = this.canvas.minimumSize;
            let diffY = (refine.height-rect.height)/2;
            refine.top  = c.y + diffY;
          }
          if (Object.keys(refine).length > 0) {
            rect.set(refine);
            rect.setCoords();
          }

          if (this.props.changeStarted) { // 入れ替え枠
            this.props.changeStarted.setDirectionType('change');
            this.props.changeStarted.set({targetTimestamp: rect.createdTimestamp});
            rect.setDirectionType('changeTarget');
            // 入れ替え
            let idx = this.canvas.getObjects().reduce((carry, o,idx)=>{
              return o === rect ? idx : carry;
            }, -1);
            rect.moveTo(idx-1);
            this.canvas.requestRenderAll();
            ProofreadHist.push(this.createSaveData());
            this.props.event({name: 'ChangeStop'});
          }
          else if (this.props.moveStarted) { // 移動枠
            this.props.moveStarted.setDirectionType('move');
            this.props.moveStarted.set({targetTimestamp: rect.createdTimestamp});
            rect.setDirectionType('moveTarget');
            // 移動
            let idx = this.canvas.getObjects().reduce((carry, o,idx)=>{
              return o === rect ? idx : carry;
            }, -1);
            rect.moveTo(idx-1);
            this.canvas.requestRenderAll();
            ProofreadHist.push(this.createSaveData());
            this.props.event({name: 'MoveStop'});
          }
          else {
            //this.props.event({name:'CreatePRRect'});
            //ProofreadHist.push(this.createSaveData());
            //this.showActionButtons(rect);
            switch (this.props.tool.replace(/^draw-/,'')) {
              case 'changePlace':
                rect.setDirectionType('change');
                this.props.event({
                  name: 'ChangeStart',
                  target: this.canvas.getActiveObject(),
                });
                break;
              case 'movePlace':
                rect.setDirectionType('move');
                this.props.event({
                  name: 'MoveStart',
                  target: this.canvas.getActiveObject(),
                });
                break;
              case 'changePhoto':
                rect.setDirectionType('changePhoto');
                this.showPhotoSelector(rect);
                break;
              case 'addPhoto':
                rect.setDirectionType('addPhoto');
                this.showPhotoSelector(rect);
                break;
              case 'trimming':
                rect.setDirectionType(rect.directionType==='triming'?'':'triming');
                this.canvas.requestRenderAll();
                ProofreadHist.push(this.createSaveData());
                break;
              case 'changeChar':
                this.setState({
                  editDialogTitle:rect.title||'',
                  editDialogToRemoveOnCancel: true,
                });
                break;
              case 'comment':
                this.setState({
                  editDialogTitle:rect.title||'',
                  editDialogToRemoveOnCancel: true,
                });
                break;
              case 'delete':
                rect.setDirectionType(rect.directionType==='delete'?'':'delete');
                this.canvas.requestRenderAll();
                ProofreadHist.push(this.createSaveData());
                break;
              case 'keep':
                rect.setDirectionType('keep');
                this.canvas.requestRenderAll();
                ProofreadHist.push(this.createSaveData());
                break;
              default:
            }
            this.props.event({name:'UpdatePRRect'});
          }
        }
        this.canvas.requestRenderAll();
        this.drawStart = false;
      }
      this.dragStart = null;
    });
    this.canvas.on('mouse:move', opt=>{
      if (!this.dragStart) return;
      if (this.props.tool === 'pan' || this.pressKey === 'space') {
        // ドラッグ移動
        let pointer = this.canvas.getPointer(opt.e, true);
        let dragEnd = new fabric.Point(pointer.x, pointer.y);
        let diff = new fabric.Point(dragEnd.x-this.dragStart.x, dragEnd.y-this.dragStart.y);
        this.canvas.relativePan(diff);
        this.dragStart = dragEnd;
        this.canvasToScrollbar();
      }
      else if (this.props.tool.match(/^draw-/) && this.drawStart) {
        // 枠の作成中
        let pointer = this.canvas.getPointer(opt.e, true);
        let w = (pointer.x - this.dragStart.x) / this.canvas.getZoom();
        let h = (pointer.y - this.dragStart.y) / this.canvas.getZoom();
        let rect = this.canvas.getActiveObject();
        if (rect) {
          let top = h > 0 ? rect.top-rect.height/2+h/2 : rect.top+rect.height/2+h/2;
          let left = w > 0 ? rect.left-rect.width/2+w/2 : rect.left+rect.width/2+w/2;
          rect.set({
            width: Math.abs(w),
            height: Math.abs(h),
            top: top,
            left: left
          });
          //rect.setCoords();
          this.canvas.requestRenderAll();
        }
      }
      else if (this.state.actionButton) {
        // 指示ボタンの位置調整
        this.showActionButtons(opt.target);
      }
    });
    this.canvas.on('selection:created', opt => {
      if (opt.e && opt.selected.length === 1 && opt.selected[0].type === 'PRRect' && !opt.selected[0].directionType.match(/Target$/)) {
        this.showActionButtons(opt.selected[0]);
        this.props.event({name:'Selected', targetTimestamp:opt.selected[0].createdTimestamp});
      }
      else if (opt.selected[0].directionType.match(/Target$/)) {
        let sourceObj = this.canvas.getObjects('PRRect').find(o=>{
          return o[opt.selected[0].directionType] === opt.selected[0].createdTimestamp;
        });
        if (sourceObj) this.props.event({name:'Selected', targetTimestamp:sourceObj.createdTimestamp});
      }
    });
    this.canvas.on('selection:updated', opt => {
      this.setState({actionButton:null});
      if (opt.e && opt.selected.length === 1 && opt.selected[0].type === 'PRRect') {
        if (!opt.selected[0].directionType.match(/Target$/)) {
          this.showActionButtons(opt.selected[0]);
          this.props.event({name:'Selected', targetTimestamp:opt.selected[0].createdTimestamp});
        }
        else {
          let sourceObj = this.canvas.getObjects('PRRect').find(o=>{
            return o[opt.selected[0].directionType] === opt.selected[0].createdTimestamp;
          });
          if (sourceObj) this.props.event({name:'Selected', targetTimestamp:sourceObj.createdTimestamp});
        }
      }
    });
    this.canvas.on('selection:cleared', opt => {
      if (this.state.photoSelector && ['draw-addPhoto','draw-changePhoto'].indexOf(this.props.tool) >= 0) {
        let objs = this.canvas.getObjects('PRRect');
        let lastObj = objs[objs.length -1];
        if (['addPhoto', 'changePhoto'].indexOf(lastObj.directionType) >= 0) {
          lastObj.canvas.remove(lastObj);
        }
      }
      this.setState({actionButton:null, photoSelector:null});
      this.props.event({name:'Selected', targetTimestamp:null});
    });
    this.canvas.on('object:modified', ()=>{
      ProofreadHist.push(this.createSaveData());
      this.props.event({name:'UpdatePRRect'});
    });

    this.LargeContainer.addEventListener('wheel', e => {
      if (this.props.tool === 'pan' || this.pressKey === 'space') {
        let pointer = this.canvas.getPointer(e, true);
        let p = new fabric.Point(pointer.x, pointer.y);
        let canvasSize = new fabric.Point(this.canvas.getWidth(), this.canvas.getHeight());
        let center = canvasSize.divide(2);
        let d = p.subtract(center);
        this.canvas.absolutePan(p.add(this.canvas.vptCoords.tl.multiply(this.canvas.getZoom()))); // 中心を原点に移動
        let zoom = e.wheelDeltaY > 0 ? 1.2 : 0.8333;
        this.canvas.setZoom(this.canvas.getZoom()*zoom);
        this.canvas.relativePan(center.add(d));
        this.canvasToScrollbar();
        e.preventDefault();
      }
    });

    // キーイベント
    document.addEventListener('keydown', e => {
      if (e.repeat) {
        e.preventDefault();
        return;
      }
      //console.log(e.key)
      if (e.metaKey) {
        let canvasSize = new fabric.Point(this.canvas.getWidth(), this.canvas.getHeight());
        switch (e.key) {
          case '0':
            this.setZoomToFitAll();
            this.updateActionButton();
            e.preventDefault();
            break;
          case '+':
            this.canvas.relativePan(new fabric.Point(0,0).subtract(canvasSize.divide(2)));
            this.canvas.setZoom(this.canvas.getZoom()*1.5);
            this.canvas.relativePan(canvasSize.divide(2));
            this.canvasToScrollbar();

            this.updateActionButton();
            e.preventDefault();
            break;
          case '-':
            this.canvas.relativePan(new fabric.Point(0,0).subtract(canvasSize.divide(2)));
            this.canvas.setZoom(this.canvas.getZoom()*0.5);
            this.canvas.relativePan(canvasSize.divide(2));
            this.canvasToScrollbar();

            this.updateActionButton();
            e.preventDefault();
            break;
          default:
        }
      }
      else {
        //console.log(e.key)
        switch (e.key) {
          case ' ':
            if (this.pressKey !== 'space') {
              this.pressKey = 'space';
              this.canvas.set({defaultCursor:'all-scroll'});
            }
            e.preventDefault();
            break;
          /*
          case 'Delete':
          case 'Backspace':
            if (e.target === document.body && !this.state.editDialog) {
              this.canvas.remove(this.canvas.getActiveObject());
            }
            break;
            */
          default:
        }
      }
    });
    document.addEventListener('keyup', e => {
      switch (e.key) {
        case ' ':
          if (this.pressKey === 'space') {
            this.pressKey = null;
            this.canvas.defaultCursor = this.getToolCursor()
          }
          break;
        default:
      }
    });
  }

  onScroll = opt => {
    if (!this.canvas || !this.canvas.vptCoords) return;
    let wh = this.canvas.vptCoords.br.subtract(this.canvas.vptCoords.tl).divide(2).multiply(this.canvas.getZoom());
    let scrollSize = new fabric.Point(this.scrollPixels.w, this.scrollPixels.h).multiply(this.canvas.getZoom());

    this.canvas.wrapperEl.style.transform = 'translate('+ this.ScrollContainer.scrollLeft+'px,'+this.ScrollContainer.scrollTop+'px)';
    let p = new fabric.Point(
      (this.ScrollContainer.scrollLeft-scrollSize.x/2+this.canvas.width  /2) - wh.x,
      (this.ScrollContainer.scrollTop -scrollSize.y/2+this.canvas.height /2) - wh.y
    );
    this.canvas.absolutePan(p);

    this.updateActionButton();
  }
  canvasToScrollbar = () => {
    let center = this.canvas.getVpCenter();
    let scrollSize = new fabric.Point(this.scrollPixels.w, this.scrollPixels.h).multiply(this.canvas.getZoom());
    this.LargeContainer.style.width = scrollSize.x+'px';
    this.LargeContainer.style.height = scrollSize.y + 'px';

    this.ScrollContainer.scrollLeft = scrollSize.x/2 + center.x * this.canvas.getZoom() - this.canvas.width /2;
    this.ScrollContainer.scrollTop  = scrollSize.y/2 + center.y * this.canvas.getZoom() - this.canvas.height /2;

    
    this.canvas.wrapperEl.style.transform = 'translate('+ this.ScrollContainer.scrollLeft+'px,'+this.ScrollContainer.scrollTop+'px)';

    if (scrollSize.x < this.canvas.width || scrollSize.y < this.canvas.height) {
      this.LargeContainer.style.width = this.canvas.width+'px';
      this.LargeContainer.style.height = this.canvas.height + 'px';
    }
    this.canvas.requestRenderAll();
  }

  // 指示ボタンの表示
  showActionButtons = PRRect => {
    if (!PRRect) return;
    PRRect.setCoords();
    let p = new fabric.Point(PRRect.oCoords.tr.x, PRRect.oCoords.tr.y);
    p = p.subtract(this.canvas.vptCoords.tl).multiply(this.canvas.getZoom());
    p = this.canvas.restorePointerVpt(p);
    this.setState({
      actionButton: {
        style: {
          left: p.x + 5,
          top: p.y - 2
        }
      }
    });
  }

  // 写真セレクタの表示
  showPhotoSelector = (PRRect, nextDirectionType) => {
    if (!PRRect) return;
    ProofreadFile.loadPhotos().then(photos=>{
      this.setState({uploadedPhotos:photos, loadingPhotoSelector:false});
    });
    PRRect.setCoords();
    let p = new fabric.Point(PRRect.oCoords.tr.x, PRRect.oCoords.tr.y);
    p = p.subtract(this.canvas.vptCoords.tl).multiply(this.canvas.getZoom());
    p = this.canvas.restorePointerVpt(p).add(new fabric.Point(5, -2));
    this.setState({
      actionButton: null,
      photoSelector: p,
      loadingPhotoSelector:true,
      nextDirectionType: nextDirectionType
    });
  }


  updateActionButton = () => {
    let rect = this.canvas.getActiveObject();
    if (!rect || this.props.tool !== 'default') return;
    setTimeout(()=>{
      if (rect) {
        if (this.state.actionButton) this.showActionButtons(rect);
        if (this.state.photoSelector) this.showPhotoSelector(rect);
      }
    }, 50);
  }

  componentDidUpdate(prevProps, prevState) {
    if (!this.props.openedStatus && this.state.loading !== true) {
      this.setState({ loading: true });
    }
    else if ( this.props.openedStatus && prevProps.openedStatus !== this.props.openedStatus) {
      if (this.props.preview) {
        // プレビュー画像の配置
        let base = new fabric.PRBase({
          previewFilename:  this.props.previewFilename
        });
        base.setSrc(URL.createObjectURL(this.props.preview), ()=>{
          base.set({
            left:-base.width/2,
            top:-base.height/2
          });
          this.canvas.add(base);
          this.setZoomToFitAll();
          this.setState({
            loading: false
          });
          ProofreadHist.init(this.createSaveData());
        });
      }
      else if (this.props.savedFabricData) {
        this.loadSaveData(this.props.savedFabricData, () => {
          this.setZoomToFitAll();
          ProofreadHist.init(this.createSaveData());
          this.props.event({name:'UpdatePRRect'});
        });
      }
      else {
        this.setState({ loading: false });
      }
    }
    else if (prevProps.tool !== this.props.tool) { // ツールの変更
      this.setState({actionButton:null});
      this.setTool();
    }
    else if (prevProps.canvasWidth !== this.props.canvasWidth || prevProps.canvasHeight !== this.props.canvasHeight) {
      this.canvas.setWidth(this.props.canvasWidth);
      this.canvas.setHeight(this.props.canvasHeight);
    }
  }

  setTool = () => {
      // ツール設定
      let selectable = true;
      let objectEventedState = true;
      let objectSelectable = true;
      if (this.props.tool.match(/^draw-/)) {
        objectEventedState = false; selectable = false; objectSelectable = true;
      }
      else {
        switch (this.props.tool) {
          case 'default': objectEventedState = true; selectable = false; objectSelectable = true; break;
          case 'pan': objectEventedState = false; selectable = false; objectSelectable = false; break;
          //case 'draw': objectEventedState = false; selectable = false; objectSelectable = true; break;
          case 'zoomPlus': objectEventedState = false; selectable = true; objectSelectable = false; break;
          case 'zoomMinus': objectEventedState = false; selectable = true; objectSelectable = false; break;
          default:
        }
      }
      this.canvas.set({
        selection: selectable,
        defaultCursor: this.getToolCursor(),
      });
      this.canvas.getObjects("PRRect").forEach(o => {
        o.evented = objectEventedState;
        o.selectable = objectSelectable
      });
  }

  getToolCursor() {
    if (this.props.tool.match(/^draw-/)) return 'crosshair';
    switch (this.props.tool) {
      case 'pan': return 'all-scroll';
      //case 'draw': return 'crosshair';
      case 'zoomPlus': return 'zoom-in';
      case 'zoomMinus': return 'zoom-out';
      default: return 'default';
    }
  }


  // 全体表示
  setZoomToFitAll() {
    let bases = this.canvas.getObjects('PRBase');
    if (bases.length === 0) return;
    let base = bases[0];
    let targetWidth = this.canvas.getWidth();
    let targetHeight = this.canvas.getHeight();
    let zoomH = targetWidth / (base.width+200);
    let zoomV = targetHeight / (base.height+200);
    let zoom = Math.min(zoomH, zoomV);
    this.canvas.setZoom(zoom);
    let center = base.getCenterPoint().multiply(zoom);
    this.canvas.absolutePan(center.subtract(new fabric.Point(targetWidth/2, targetHeight/2)));
    //this.canvas.viewportCenterObject(preview); // 原点がずれるので使わない！！
    this.canvasToScrollbar();
  }
  zoomToCenter(plus) {
    let magnify = this.canvas.getZoom()* (plus ? 1.2 : 1/1.2);
    
    let canvasSize = new fabric.Point(this.canvas.getWidth(), this.canvas.getHeight());
    this.canvas.relativePan(new fabric.Point(0,0).subtract(canvasSize.divide(2)));
    this.canvas.setZoom(magnify);
    this.canvas.relativePan(canvasSize.divide(2));
    this.canvasToScrollbar();
  }

  loadSaveData = (fabricData, callback) => {
    fabricData.objects = fabricData.objects.map(o=>{
      if (['PRTextRect','PRPoint'].indexOf(o.type) >= 0) o.type = 'PRRect'; // 変換
      return o;
    });
    this.canvas.loadFromJSON(fabricData, () => {
      //this.setZoomToFitAll();
      this.setState({ loading: false, selectedDirection:null});
      this.setTool();

      if (callback) callback();
    });
  }

  // undo, redo
  undo = () => {
    let data = ProofreadHist.prev();
    if (data) {
      let bases = this.canvas.getObjects('PRBase');
      let grayscale = bases.length > 0 ? bases[0].grayscale : false;
      this.setState({loading:'作業の取り消し'});
      this.loadSaveData(data, ()=>{
        this.props.event({name:'UpdatePRRect'});
        let bases = this.canvas.getObjects('PRBase');
        if (bases.length > 0) bases[0].set({grayscale: grayscale});
      });
    }
  }
  redo = () => {
    let data = ProofreadHist.next();
    if (data) {
      let bases = this.canvas.getObjects('PRBase');
      let grayscale = bases.length > 0 ? bases[0].grayscale : false;
      this.setState({loading:'作業のやり直し'});
      this.loadSaveData(data, ()=>{
        this.props.event({name:'UpdatePRRect'});
        let bases = this.canvas.getObjects('PRBase');
        if (bases.length > 0) bases[0].set({grayscale: grayscale});
      });
    }
  }

  // 指示ボタン
  onClickActionButton = (opt) => {
    if (this.props.openedStatus !== 'opened') return null;
    if (opt.target.classList.contains('ChangeButton')) {
      this.props.event({
        name: 'ChangeStart',
        target: this.canvas.getActiveObject(),
      });
      this.setState({actionButton:false})
    }
    else if (opt.target.classList.contains('ChangePhotoButton')) {
      let obj = this.canvas.getActiveObject();
      this.showPhotoSelector(obj, 'changePhoto');
    }
    else if (opt.target.classList.contains('AddPhotoButton')) {
      let obj = this.canvas.getActiveObject();
      this.showPhotoSelector(obj, 'addPhoto');
    }
    else if (opt.target.classList.contains('TextButton')) {
      let obj = this.canvas.getActiveObject();
      this.setState({
        editDialogTitle:obj.title||'',
        editDialogToRemoveOnCancel:false,
      });
    }
    else if (opt.target.classList.contains('TrimingButton')) {
      let obj = this.canvas.getActiveObject();
      obj.setDirectionType(obj.directionType==='triming'?'':'triming');
      this.canvas.requestRenderAll();
      ProofreadHist.push(this.createSaveData());
    }
    else if (opt.target.classList.contains('DeleteButton')) {
      let obj = this.canvas.getActiveObject();
      obj.setDirectionType(obj.directionType==='delete'?'':'delete');
      this.canvas.requestRenderAll();
      ProofreadHist.push(this.createSaveData());
      this.props.event({name:'UpdatePRRect'});
    }
    else if (opt.target.classList.contains('RemoveButton')) {
      this.setState({actionButton:false});
      let obj = this.canvas.getActiveObject();
      if (['change','move','changeChar'].indexOf(obj.directionType)>=0) {
        let targetFrame = this.canvas.getObjects('PRRect').find(o=>{
          return o.createdTimestamp === obj.targetTimestamp;
        });
        if (targetFrame) {
          this.canvas.remove(targetFrame);
        }
      }
      this.canvas.remove(obj);
      ProofreadHist.push(this.createSaveData());
    }
    this.props.event({name:'UpdatePRRect'});
  }

  removeSelectedDirection = () => {
    let obj = this.canvas.getActiveObject();
    //console.log(obj)
    if (!obj) return;
    if (['change','move','changeChar'].indexOf(obj.directionType)>=0) {
      let targetObj = this.canvas.getObjects('PRRect').find(o=>{
        return o.createdTimestamp === obj.targetTimestamp;
      });
      if (targetObj) {
        this.canvas.remove(targetObj);
      }
    }
    else if (obj.directionType.match(/Target$/) ) {
      let parentObj = this.canvas.getObjects('PRRect').find(o=>{
        return obj.createdTimestamp === o.targetTimestamp;
      });
      if (parentObj) {
        this.canvas.remove(parentObj);
      }
    }
    this.canvas.remove(obj);
    //ProofreadHist.push(this.createSaveData());
  }

  cancelCreateTarget = () => {
    this.canvas.getObjects('PRRect').forEach(o=>{
      if (['change', 'move'].indexOf(o.directionType) >= 0 && !o.targetTimestamp) o.canvas.remove(o);
    });
  }

  // コメント入力
  onClickEditDialogButton = opt => {
    if (opt.target.classList.contains('ProofreadCanvas-EditDialog-CancelButton')) {
      if (this.state.editDialogToRemoveOnCancel) {
        this.removeSelectedDirection();
      }
      this.setState({editDialogTitle:null,editDialogToRemoveOnCancel:false});
    }
    else if (opt.target.classList.contains('ProofreadCanvas-EditDialog-OKButton')) {
      let obj = this.canvas.getActiveObject();
      if (obj.directionType.match(/Target$/)) {
        obj = this.canvas.getObjects('PRRect').find(o=>{
          return obj.createdTimestamp === o.targetTimestamp;
        });
      }
      obj.set({title:this.state.editDialogTitle});
      this.setState({editDialogTitle:null, editDialogToRemoveOnCancel:false});
      this.canvas.requestRenderAll();
      ProofreadHist.push(this.createSaveData());
    }
    this.props.event({name:'UpdatePRRect'});
  }
  onChangeEditDialogTitle = e => {
    this.setState({editDialogTitle:e.target.value, editDialogToRemoveOnCancel:false});
    this.props.event({name:'UpdatePRRect'});
  }

  updateDirection = (direction, timestamp) => {
    //let obj = this.canvas.getActiveObject();
    let objs = this.canvas.getObjects().filter(o=>['PRRect'].indexOf(o.type)>=0&&!o.directionType.match(/Target$/));
    objs = objs.filter(o=> o.createdTimestamp.toString() === timestamp);
    if (objs.length === 0) return;
    let obj = objs[0];
    obj.set(direction);
    this.canvas.requestRenderAll();
    ProofreadHist.push(this.createSaveData());
    this.props.event({name:'UpdatePRRect'});
  }

  onClickPhotoSelector = e => {
    let obj = this.canvas.getActiveObject();
    if (!obj) return;
    if (!e.target.dataset.name) return;
    obj.setPhoto(e.target.dataset.name);
    if (this.state.nextDirectionType) obj.directionType = this.state.nextDirectionType;
    this.canvas.requestRenderAll();
    this.setState({photoSelector:null, nextDirectionType:null });
    ProofreadHist.push(this.createSaveData());
    this.props.event({name:'UpdatePRRect'});
  }

  createSaveData = () => {
    var hideObjs = this.canvas.getObjects('PRRect').filter(o=>{return !o.visible; });
    hideObjs.forEach(o=>{
      o.visible = true;
    });
    let fabricData = this.canvas.toObject();
    delete fabricData.background;
    hideObjs.forEach(o=>{
      o.visible = false;
    });

    fabricData.savedTimestamp = Utils.getTimestamp();
    fabricData.saveFrom = 'customer';

    return fabricData;
  }
  createPreview = () => {
    // 選択解除
    var act = this.canvas.getActiveObject();
    if (act) this.canvas.discardActiveObject();

    var hideObjs = this.canvas.getObjects('PRRect').filter(o=>{return !o.visible; });
    hideObjs.forEach(o=>{
      o.visible = true;
    });
    let prevVpt = JSON.parse(JSON.stringify(this.canvas.viewportTransform));
    this.canvas.setViewportTransform([ 1, 0,  0, 1, 0, 0 ]);
    var bases = this.canvas.getObjects('PRBase');
    if (bases.length === 0) return;
    let grayscale = bases[0].grayscale;
    bases[0].set({grayscale: false});
    this.canvas.requestRenderAll();
    var dataURI = this.canvas.toDataURL({
      format: 'jpeg',
      left: bases[0].left,
      top: bases[0].top,
      width: bases[0].width,
      height: bases[0].height,
    });
    this.canvas.setViewportTransform(prevVpt);
    hideObjs.forEach(o=>{
      o.visible = false;
    });
    bases[0].set({grayscale: grayscale});
    this.canvas.requestRenderAll();
    var binary = atob(dataURI.split(',')[1]), array = [];
    for(var i = 0; i < binary.length; i++) array.push(binary.charCodeAt(i));


    this.canvas.setActiveObject(act);

    return new Blob([new Uint8Array(array)], {type: 'image/jpeg'});
  }
  clear = () => {
    this.canvas.clear();
    this.setState({
      loading: true
    });
  }


  selectDirection = timestamp => {
    this.setState({ selectedDirection: timestamp });
    let objs = this.canvas.getObjects();
    if (timestamp) {
      objs.filter(o=>o.directionType&&!o.directionType.match(/Target$/)).forEach(o=>{
        if (o.directionType === 'change') {
          let t = objs.find(t=>t.createdTimestamp===o.targetTimestamp);
          if (t) t.visible = o.createdTimestamp.toString() === timestamp;
        }
        else if (o.directionType === 'move') {
          let t = objs.find(t=>t.createdTimestamp===o.targetTimestamp);
          if (t) t.visible = o.createdTimestamp.toString() === timestamp;
        }
        else if (o.directionType === 'changeChar') {
          let t = objs.find(t=>t.createdTimestamp===o.targetTimestamp);
          if (t) t.visible = o.createdTimestamp.toString() === timestamp;
        }
        o.visible = o.createdTimestamp.toString() === timestamp;
      });
    }
    else {
      objs.forEach(o=>{
        o.visible = true;
      });
    }
    this.canvas.requestRenderAll();
  }

  getDirections = () => {
    let PRRects = this.canvas.getObjects().filter(o=>o.type!=='PRBase'&&!o.directionType.match(/Target$/)).sort((o1, o2)=>o1 - o2).map((o,idx)=>{
      o.num = idx+1;
      return o;
    });

    return PRRects;
  }

  onClickZoomTool = e => {
    switch (e.target.dataset.toolName) {
      /*
      case 'grayscale':
        let base = this.canvas.getObjects('PRBase');
        if (base.length === 0) return;
        base[0].set({grayscale: !base[0].grayscale});
        this.canvas.requestRenderAll();
        break;
        */
      case 'zoomPlus':
      case 'zoomMinus':
        let magnify = this.canvas.getZoom()* (e.target.dataset.toolName === 'zoomPlus' ? 1.2 : 1/1.2);
        
        let canvasSize = new fabric.Point(this.canvas.getWidth(), this.canvas.getHeight());
        this.canvas.relativePan(new fabric.Point(0,0).subtract(canvasSize.divide(2)));
        this.canvas.setZoom(magnify);
        this.canvas.relativePan(canvasSize.divide(2));
        this.canvasToScrollbar();
        break;
      default:
    }
  }

  toggleDirectionView = () => {
    let base = this.canvas.getObjects('PRBase');
    if (base.length === 0) return;
    base[0].set({grayscale: !base[0].grayscale});
    this.canvas.requestRenderAll();
  }

  render () {
    return ( 
      <LoadingOverlay active={!!this.state.loading} spinner text={this.state.loading}>
        <div id="Proofread-scroll-container" onScroll={this.onScroll} ref={ref=>{this.ScrollContainer=ref;}}>
          <div id="Proofread-large-container"  ref={ref=>{this.LargeContainer=ref;}}>
            <canvas id="ProofreadCanvas"></canvas>
          </div>
        </div>
        <div className="ProofreadCanvas-ZoomTool" onClick={this.onClickZoomTool}>
          {/*<button className="toolBtn" data-tool-name="grayscale" title="グレー表示"><FontAwesomeIcon icon={faGlasses}></FontAwesomeIcon></button>*/}
          <button className="toolBtn" data-tool-name="zoomPlus" title="拡大"><FontAwesomeIcon icon={faSearchPlus}></FontAwesomeIcon></button>
          <button className="toolBtn" data-tool-name="zoomMinus" title="縮小"><FontAwesomeIcon icon={faSearchMinus}></FontAwesomeIcon></button>
        </div>
        { this.state.actionButton
          ? (
            <div className="ProofreadCanvas-ActionButtons" style={this.state.actionButton.style} onClick={this.onClickActionButton}>
              <div className="ProofreadCanvas-ActionButton ChangeButton" title="写真の入れ替え指示"></div>
              <div className="ProofreadCanvas-ActionButton ChangePhotoButton" title="新しい写真に差し替え指示"><FontAwesomeIcon icon={faImage}></FontAwesomeIcon></div>
              <div className="ProofreadCanvas-ActionButton AddPhotoButton" title="写真の追加指示"><FontAwesomeIcon icon={faSquarePlus}></FontAwesomeIcon></div>
              <div className="ProofreadCanvas-ActionButton TrimingButton" title="トリミング指示"><FontAwesomeIcon icon={faCropSimple}></FontAwesomeIcon></div>
              <div className="ProofreadCanvas-ActionButton TextButton" title="指示の入力"><FontAwesomeIcon icon={faMessage}></FontAwesomeIcon></div>
              <div className="ProofreadCanvas-ActionButton DeleteButton" title="写真・枠の削除指示"></div>
              <div className="ProofreadCanvas-ActionButtons-Separate"></div>
              <div className="ProofreadCanvas-ActionButton RemoveButton" title="指示の削除"><FontAwesomeIcon icon={faTrash}></FontAwesomeIcon></div>
            </div>
          )
          : null
        }
        {
          this.state.editDialogTitle !== null
          ? (
            <div className="ProofreadCanvas-EditDialog">
              <div className="ProofreadCanvas-EditDialog-Window">
                <div className="ProofreadCanvas-EditDialog-Header"></div>
                <div className="ProofreadCanvas-EditDialog-Body">
                  <div className="ProofreadCanvas-EditDialog-Row">
                    <div className="ProofreadCanvas-EditDialog-Label">指示詳細</div>
                    <div className="ProofreadCanvas-EditDialog-Value">
                      <textarea value={this.state.editDialogTitle} onChange={this.onChangeEditDialogTitle}></textarea>
                    </div>
                  </div>
                  <div className="ProofreadCanvas-EditDialog-Buttons" onClick={this.onClickEditDialogButton}>
                    <button className="ProofreadCanvas-EditDialog-CancelButton">キャンセル</button>
                    <button className="ProofreadCanvas-EditDialog-OKButton">OK</button>
                  </div>
                </div>
              </div>
            </div>
          )
          : null
        }
        {
          this.state.photoSelector
          ? (

              <div className="ProofreadCanvas-PhotoSelector" onClick={this.onClickPhotoSelector}
                style={{left: this.state.photoSelector.x,top:this.state.photoSelector.y}}>
                <LoadingOverlay className="ProofreadCanvas-PhotoSelector-Loader" active={!!this.state.loadingPhotoSelector} spinner text={this.state.loadingPhotoSelector}>
                  <div className="ProofreadCanvas-PhotoSelector-Body">{
                    this.state.uploadedPhotos.map((p, idx)=>{
                      let name = p.name.replace(/_[^_/]+(\.[^.]+)$/, '$1');
                      return (<div key={idx} className="ProofreadCanvas-PhotoSelector-Row" data-name={p.name}>
                        <img src={"data:image/jpeg;base64,"+p.thumbnail} alt={name}/>
                        <div>{name}</div>
                      </div>)
                    })
                  }</div>
                </LoadingOverlay>
              </div>
          )
          : null
        }
        {
          this.props.openedStatus && ['opened', 'reopen'].indexOf(this.props.openedStatus) < 0
          ? (
            <div className="ProofreadCanvas-OpenedStatus">
              <div className="ProofreadCanvas-OpenedStatus-Dialog">
                {
                  (()=>{
                    switch (this.props.openedStatus) {
                      case 'otherOpened': return "他の人が作業中のようです。";
                      default: return 'エラー';
                    }
                  })()
                }
              </div>
            </div>
          )
          : null
        }
      </LoadingOverlay>
    );
  }
}
export default ProofreadCanvas;